import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('KmToMeters', KmToMeters);

function KmToMeters() {
  const KM = 1000;

  return function kmToMetersFilter(distance) {
    return _.isNumber(distance) ? distance * KM : 0;
  }
}
